// apps/web/src/features/call-center/components/callCenterLeadGrid.ts
//
// Shared CSS-grid column template for the external agent's own-leads table
// (#1398): Phone / Client name / Comment / Call-recording link / Added at.
// Kept in one module so the header row and the body rows never drift apart.
export const GRID_TEMPLATE = '160px minmax(160px,1fr) minmax(200px,2fr) 140px 180px';
